// extracted by mini-css-extract-plugin
module.exports = {"example":"e_h9","exampleLabel":"e_i9","exampleIntro":"e_j9"};